enum ActionButtonStyle {
	Standard,
	Bordered,
	Text,
}

export default ActionButtonStyle;
